import style from '../styles/layout.module.css';

const TableHead = ({ children }) => {
  return <thead className={`thead-dark ${style.table_head}`}>{children}</thead>;
};

export default TableHead;
